import { ENV, LocalStorageService } from "@/utils";
import axios from "axios";
import { AuthApi } from "./auth";

// P.S: USED ONLY FOR SUPPORT CHATS DUE TO BACKEND LOGIC

export const supportInstance = axios.create({
  baseURL: `${ENV.VITE_BACKEND_API_URL}/v1/`,
  timeout: 50000,
});

supportInstance.interceptors.request.use(
  async (config) => {
    const supportAccessToken = LocalStorageService.getSupportAccessToken();

    if (supportAccessToken) {
      config.headers["Authorization"] = `Bearer ${supportAccessToken}`;
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

supportInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  async (error) => {
    const originalRequest = error.config;
    const { statusCode, message } = error.response.data;

    if ((message === "invalid token" || message === "invalid signature") && statusCode === 401) {
      window.location.href = "/login";
      LocalStorageService.deleteSupportAuthTokens();

      return Promise.reject();
    }

    if (message === "jwt expired" && statusCode === 401) {
      originalRequest._retry = true;
      const refreshToken = LocalStorageService.getSupportRefreshToken();

      if (refreshToken) {
        try {
          const newTokens = await AuthApi.refreshLogin({ refreshToken });

          LocalStorageService.setSupportAccessToken(newTokens.accessToken);
          LocalStorageService.setSupportRefreshToken(newTokens.refreshToken);

          originalRequest.headers[
            "Authorization"
          ] = `Bearer ${newTokens.accessToken}`;

          return axios(originalRequest);
        } catch (refreshError) {
          LocalStorageService.deleteSupportAuthTokens();
          window.location.href = "/login";

          console.error("Support token refresh failed", refreshError);
          return Promise.reject(refreshError);
        }
      }
    }
    return Promise.reject(error);
  }
);

export { supportInstance as supportAxios };
